import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CamionesService {

  server: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/camiones";
    this.token = this.auth.getToken();
  }

  getCamiones(estado: string) {
    return this.httpClient.get(this.server+'/'+estado);
  }

  newCamion(marca: string, modelo: string, matricula: string, activo: string) {
    const formData = new FormData();
    formData.append('marca', marca);
    formData.append('modelo', modelo);
    formData.append('matricula', matricula);
    formData.append('activo', activo);
    return this.httpClient.post(this.server, formData);
  }

  editCamion(id: number, marca: string, modelo: string, matricula: string, activo: string) {
    const formData = new FormData();
    formData.append('idCamion', id.toString());
    formData.append('marca', marca);
    formData.append('modelo', modelo);
    formData.append('matricula', matricula);
    formData.append('activo', activo);
    return this.httpClient.post(this.server+"/update", formData);
  }

  deleteCamion(id: number){
    return this.httpClient.delete(this.server+"/"+id);
  }

}
